module.exports = __webpack_public_path__ + "img/aurora.95d0294c.svg";